import { useEffect, useState } from 'react';
import { MISSION_PROGRESS_TIMER_COLORS } from 'shared/components/MissionsProgress/constants';

const useFlickerTimer = ({ isTwoHoursRemaining = false, isTenMinutesRemaining = false, intervalMs = 1000 }) => {
  const [isFlicker, setIsFlicker] = useState(false);

  useEffect(() => {
    if (!isTenMinutesRemaining) {
      setIsFlicker(false);
      return;
    }

    const interval = setInterval(() => {
      setIsFlicker(prev => !prev);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [isTenMinutesRemaining, intervalMs]);

  return {
    isFlicker,
    color: !isTwoHoursRemaining
      ? MISSION_PROGRESS_TIMER_COLORS.REGULAR
      : !isTenMinutesRemaining || isFlicker
        ? MISSION_PROGRESS_TIMER_COLORS.DANGER_ORANGE
        : MISSION_PROGRESS_TIMER_COLORS.DANGER_PURPLE,
  };
};

export default useFlickerTimer;

